export enum YesNoEnum {
  YES = 'YES',
  NO = 'NO',
}
